module.exports = __webpack_public_path__ + "static/wireframes-f7a6b3e628959eb0f4b0819676aaedc5.png";